import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { FiMenu, FiX, FiChevronDown, FiChevronLeft } from 'react-icons/fi';
import logo from '../images/logo.png'; // Make sure this path is correct

const managementOptions = [
  'Leadership', 'Business Environment', 'Business Ethics', 'Cost & Management Accounting', 'Managerial Communication',
  'Digital Marketing', 'Business Statistics', 'Supply Chain Management', 'Market Research', 'Entrepreneurship',
  'Managerial Economics', 'Business Communication', 'International Business', 'Operations Management', 'Marketing Management',
  'Marketing', 'Customer Relationship Management', 'Organizational Behavior', 'Financial Management', 'Accounting',
  'Human Resources', 'Corporate Management'
];
const lawOptions = [
  'Corporate Law', 'Criminal Law', 'Civil Law', 'Intellectual Property', 'Contract Law',
  'Constitutional Law', 'Family Law', 'Tax Law', 'Environmental Law', 'International Law',
  'Human Rights Law', 'Administrative Law'
];
const financeOptions = [
  'Corporate Finance', 'Investment Banking', 'Financial Accounting', 'Risk Management', 'Portfolio Management',
  'Financial Markets', 'Derivatives', 'Behavioral Finance', 'Public Finance', 'International Finance'
];
const engineeringOptions = [
  'Civil Engineering', 'Mechanical Engineering', 'Electrical Engineering', 'Chemical Engineering', 'Computer Engineering',
  'Aerospace Engineering', 'Biomedical Engineering', 'Software Engineering', 'Industrial Engineering', 'Environmental Engineering'
];
const programmingOptions = [
  'Python', 'Java', 'JavaScript', 'C++', 'C#', 'PHP', 'Ruby', 'Swift', 'Kotlin',
  'Web Development', 'Mobile Development', 'Data Structures', 'Algorithms', 'Database Management', 'AI & Machine Learning'
];
const networkingOptions = [
  'Network Design', 'Network Security', 'TCP/IP Suite', 'Cisco Technologies', 'Wireless Networking',
  'Cloud Networking', 'Network Protocols', 'Cybersecurity', 'Network Administration', 'VoIP'
];
const artsHumanitiesOptions = [
  'History', 'Literature', 'Philosophy', 'Fine Arts', 'Music Theory', 'Theatre Studies',
  'Religious Studies', 'Linguistics', 'Archaeology', 'Cultural Studies', 'Ethics'
];
const scienceOptions = [
  'Physics', 'Chemistry', 'Biology', 'Environmental Science', 'Geology', 'Astronomy',
  'Mathematics', 'Statistics', 'Neuroscience', 'Genetics', 'Ecology'
];

const assignmentSubmenus = {
  Management: managementOptions, Law: lawOptions, Finance: financeOptions, Engineering: engineeringOptions,
  Programming: programmingOptions, Networking: networkingOptions, 'Arts & Humanities': artsHumanitiesOptions, Science: scienceOptions,
};

const leadershipAreaOptions = [];
const leadershipSubOptions = ['Option 1', 'Option 2', 'Option 3', 'Option 4'];
const leadershipDetailOptions = {
  'Option 1': ['Detail 1.1', 'Detail 1.2', 'Detail 1.3', 'Detail 1.4'],
  'Option 2': ['Detail 2.1', 'Detail 2.2', 'Detail 2.3', 'Detail 2.4'],
  'Option 3': ['Detail 3.1', 'Detail 3.2', 'Detail 3.3', 'Detail 3.4'],
  'Option 4': ['Detail 4.1', 'Detail 4.2', 'Detail 4.3', 'Detail 4.4'],
};

function Navbar() {
  const [isOpen, setIsOpen] = useState(false);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  useEffect(() => {
    const handleOutsideClick = (e) => {
      if (isOpen && !e.target.closest('.mobile-menu') && !e.target.closest('.menu-icon')) {
        setIsOpen(false);
      }
      if (isDropdownOpen && !e.target.closest('.dropdown-container')) {
        setIsDropdownOpen(false);
      }
    };
    document.addEventListener('click', handleOutsideClick);
    return () => document.removeEventListener('click', handleOutsideClick);
  }, [isOpen, isDropdownOpen]);

  const closeAllMenus = () => {
    setIsOpen(false);
    setIsDropdownOpen(false);
  }

  const assignmentCategories = Object.keys(assignmentSubmenus);

  return (
    <nav className='bg-[#02042b] text-white w-full h-20 px-4 flex items-center justify-between fixed top-0 left-0 z-50 font-[Poppins]'>
      <Link to="/" onClick={closeAllMenus}>
        <img src={logo} alt="Logo" className="w-36 sm:w-40 h-auto pl-1 sm:p-2 -ml-2 sm:ml-2" />
      </Link>

      {/* MOBILE MENU ICON */}
      <div className="lg:hidden cursor-pointer text-3xl menu-icon z-50"
           onClick={(e) => { e.stopPropagation(); setIsOpen(!isOpen); }}>
        {isOpen ? <FiX /> : <FiMenu />}
      </div>

      {/* DESKTOP MENU */}
      <ul className='hidden lg:flex space-x-8 pr-8 text-lg font-semibold tracking-wide'>
        <li><Link to="/" onClick={closeAllMenus}>Home</Link></li>
        <li><Link to="/aboutus" onClick={closeAllMenus}>About Us</Link></li>

        {/* SERVICES DROPDOWN */}
        <li className="relative dropdown-container">
          <button className='flex items-center gap-1' onClick={(e) => { e.stopPropagation(); setIsDropdownOpen(!isDropdownOpen); }}>
            Services <FiChevronDown className={`${isDropdownOpen ? 'rotate-180' : ''}`} />
          </button>

          <ul className={`dropdown-menu absolute right-0 w-56 bg-white text-black rounded-lg shadow-lg mt-2 ${isDropdownOpen ? "block" : "hidden"}`}>
            <li className="relative group/level1">
              <span className="block w-full text-left px-4 py-2">Assignment Assistance</span>

              <ul className="absolute right-full top-0 w-56 bg-blue-100 rounded-lg shadow-lg hidden group-hover/level1:block z-[60]">
                {assignmentCategories.map((category) => (
                  <li key={category} className="relative group/level2 hover:bg-gray-200">
                    <Link to="/services" onClick={closeAllMenus}
                      className="w-full text-left px-4 py-2 flex justify-start items-center">
                      {assignmentSubmenus[category] && <FiChevronLeft className='text-sm' />}
                      {category}
                    </Link>

                    {assignmentSubmenus[category] && (
                      <ul className="absolute right-full top-0 w-60 bg-red-100 rounded-lg shadow-lg hidden group-hover/level2:block z-[70]">
                        {assignmentSubmenus[category].map((option) => {
                          const isLeadership = category === 'Management' && option === 'Leadership';
                          return (
                            <li key={option} className="relative group/level3 hover:bg-gray-200">
                              <Link to="/services" onClick={closeAllMenus} className="flex-grow px-4 py-2">
                                {option}
                              </Link>

                              {isLeadership && (
                                <ul className="absolute right-full top-0 w-60 bg-yellow-100 text-black rounded-lg shadow-lg mr-1 hidden group-hover/level3:block z-[80]">
                                  {leadershipAreaOptions.map((areaOption) => (
                                    <li key={areaOption} className="relative group/level4 hover:bg-gray-200">
                                      <Link to="/services" onClick={closeAllMenus} className="flex-grow px-4 py-2">
                                        {areaOption}
                                      </Link>

                                      <ul className="absolute right-full top-0 w-60 bg-white text-black rounded-lg shadow-lg mr-1 hidden group-hover/level4:block z-[90]">
                                        {leadershipSubOptions.map((subOption) => (
                                          <li key={subOption} className="relative group/level5 hover:bg-gray-200">
                                            <Link to="/services" onClick={closeAllMenus} className="flex-grow px-4 py-2">
                                              {subOption}
                                            </Link>

                                            {leadershipDetailOptions[subOption] && (
                                              <ul className="absolute right-full top-0 w-60 bg-gray-100 text-black rounded-lg shadow-lg mr-1 hidden group-hover/level5:block z-[100]">
                                                {leadershipDetailOptions[subOption].map((detail) => (
                                                  <li key={detail} className="hover:bg-gray-200">
                                                    <Link to="/services" onClick={closeAllMenus} className="block px-4 py-2">
                                                      {detail}
                                                    </Link>
                                                  </li>
                                                ))}
                                              </ul>
                                            )}
                                          </li>
                                        ))}
                                      </ul>
                                    </li>
                                  ))}
                                </ul>
                              )}
                            </li>
                          );
                        })}
                      </ul>
                    )}
                  </li>
                ))}
              </ul>
            </li>

            <li><Link to="/services" onClick={closeAllMenus} className="block px-4 py-2">Study Abroad Guidance</Link></li>
          </ul>
        </li>

        {/* ACADEMIC TOOLS */}
        <li className="relative group">
          <button className='flex items-center gap-1'>Academic Tools <FiChevronDown /></button>
          <div className="absolute left-0 w-60 bg-white text-black rounded-lg shadow-lg mt-2 opacity-0 group-hover:opacity-100 invisible group-hover:visible transition-all duration-200 z-[60]">
            <ul>
              <li><Link to="/grammar-checker" onClick={closeAllMenus} className="block px-4 py-2 hover:bg-gray-200">Grammar Checker</Link></li>
              {/* <li><Link to="/plagiarism-checker" onClick={closeAllMenus} className="block px-4 py-2 hover:bg-gray-200">Plagiarism Checker</Link></li>
              <li><Link to="/paraphrasing-tool" onClick={closeAllMenus} className="block px-4 py-2 hover:bg-gray-200">Paraphrasing Tool</Link></li> */}
              {/* <li><Link to="/essay-typer" onClick={closeAllMenus} className="block px-4 py-2 hover:bg-gray-200">Essay Typer</Link></li>
              <li><Link to="/essay-checker" onClick={closeAllMenus} className="block px-4 py-2 hover:bg-gray-200">Essay Checker</Link></li> */}
            </ul>
          </div>
        </li>

        {/* RESOURCES */}
        <li className="relative group">
          <button className='flex items-center gap-1'>Resources <FiChevronDown /></button>
          <div className="absolute left-0 w-40 bg-white text-black rounded-lg shadow-lg mt-2 opacity-0 group-hover:opacity-100 invisible group-hover:visible transition-all duration-200 z-[60]">
            <ul>
              <li><Link to="/samples" onClick={closeAllMenus} className="block px-4 py-2 hover:bg-gray-200">Samples</Link></li>
              <li><Link to="/whyus" onClick={closeAllMenus} className="block px-4 py-2 hover:bg-gray-200">Blogs</Link></li>
            </ul>
          </div>
        </li>

        <li><Link to="/contactus" onClick={closeAllMenus}>Contact Us</Link></li>

        {/* ORDER NOW BUTTON */}
        <li>
          <Link
            to="/order"
            onClick={closeAllMenus}
            className="rounded-full bg-gradient-to-r from-yellow-300 to-yellow-500 text-black font-semibold px-4 py-2 hover:from-yellow-400 hover:to-yellow-600 transition-all duration-200"
          >
            Order Now
          </Link>
        </li>
      </ul>

      {/* MOBILE MENU */}
      <div className={`mobile-menu lg:hidden fixed top-0 left-0 w-full h-screen bg-[#02042b] flex flex-col items-center justify-center 
      ${isOpen ? "translate-x-0" : "-translate-x-full"} z-40`}>
        
        <button className="absolute top-6 right-5 text-4xl text-white z-50" 
                onClick={() => setIsOpen(false)}>
          <FiX />
        </button>

        <ul className="flex flex-col items-center space-y-6 text-xl font-semibold text-white pt-10 pb-10">
          <li><Link to="/" onClick={closeAllMenus}>Home</Link></li>
          <li><Link to="/aboutus" onClick={closeAllMenus}>About Us</Link></li>

          <li>
            <details className="text-center">
              <summary className="cursor-pointer">Academic Tools</summary>
              <ul className="text-sm mt-2 space-y-2">
                <li><Link to="/grammar-checker" onClick={closeAllMenus}>Grammar Checker</Link></li>
                {/* <li><Link to="/plagiarism-checker" onClick={closeAllMenus}>Plagiarism Checker</Link></li>
                <li><Link to="/paraphrasing-tool" onClick={closeAllMenus}>Paraphrasing Tool</Link></li>
                <li><Link to="/essay-typer" onClick={closeAllMenus}>Essay Typer</Link></li>
                <li><Link to="/essay-checker" onClick={closeAllMenus}>Essay Checker</Link></li> */}
              </ul>
            </details>
          </li>

          <li><Link to="/services" onClick={closeAllMenus}>Services</Link></li>

          <li className="relative group">
            <details className="text-center">
              <summary className="cursor-pointer">Resources</summary>
              <ul className="text-sm mt-2 space-y-2">
                <li><Link to="/samples" onClick={closeAllMenus}>Samples</Link></li>
                <li><Link to="/whyus" onClick={closeAllMenus}>Blogs</Link></li>
              </ul>
            </details>
          </li>

          <li><Link to="/contactus" onClick={closeAllMenus}>Contact Us</Link></li>

          <li className="rounded-full bg-gradient-to-r from-yellow-300 to-yellow-500 text-black font-semibold px-4 py-2 hover:from-yellow-400 hover:to-yellow-600 transition-all duration-200">
            <Link to="/order" onClick={closeAllMenus}>Order Now</Link>
          </li>
        </ul>
      </div>
    </nav>
  );
}

export default Navbar;
